<template>
    <div id="container-graph">
        <a
            id="btn-fullscreen"
            @click="showFullScreen = true"
        >
            <img src="@/assets/images/fullscreen.png">
        </a>
        <div 
            v-if="showFullScreen" 
            id="contnent-graph-fullscreen"
        >
            <div id="content-fullscreen">
                <a 
                    id="btn-close-fullscreen" 
                    class="btn btn-close"
                    @click="showFullScreen = false" 
                />
                <highcharts 
                    :id="idDiv" 
                    :options="chartOptions" 
                />
            </div>
        </div>
        <highcharts 
            :id="idDiv" 
            :options="chartOptions" 
        />
    </div>
</template>

<script>
    export default {
        name: 'Graph',

        props: {
            xleyend: [],
            yleyend: String,
            dataSeries: [],
            chartTitle: String,
            idDiv: Number
        },

        data() {
            return {
                chartOptions: {
                    chart: {
                        backgroundColor: {
                            linearGradient: [0, 0, 500, 500],
                            stops: [
                                [0, 'rgb(255, 255, 255)'],
                                [1, 'rgb(240, 240, 255)']
                            ]
                        },
                        zoomType: "y",
                        borderWidth: 1,
                        borderColor: 'rgba(255, 115, 0, 0.8)',
                        plotBackgroundColor: 'rgba(255, 255, 255, .9)',
                        plotShadow: false,
                        plotBorderWidth: 1
                    },

                    credits:{
                        enabled: false
                    },

                    title: {
                        text: this.chartTitle
                    },

                    subtitle:{
                        text: "Fuente: IDEA"
                    },

                    xAxis: {
                        categories: this.xleyend,
                        minTickInterval: this.dataSeries[0].data.length/3
                    },

                    yAxis: {
                        title:{
                            text: this.yleyend
                        }
                    },

                    exporting:{
                        buttons: {
                            contextButton: {
                                menuItems: ['viewFullscreen','printChart','downloadPNG', 'downloadSVG','downloadJPEG','downloadPDF']
                            }
                        },
                    },

                    series: this.dataSeries
                },
                showFullScreen: false
            }
        }
    };
</script>

<style scoped lang="scss">
    #container-graph {
        #btn-fullscreen {
            display: flex;
            border: 1px solid rgb(255, 115, 0);
            border-radius: .3em;
            width: 2.5em;
            padding: .5em;
            margin: 0 0 2px auto;

            img {
                width: 100%;
                height: auto;
            }
        }

        #btn-fullscreen:hover{
            background: rgba(255, 115, 0, 0.4);
        }

        #contnent-graph-fullscreen{
            position: fixed;
            display:flex;
            justify-content: center;
            align-items: center;
            text-align: right;
            z-index: 2;
            top: 0;
            left: 0;
            background-color: rgba(0, 0, 0, 0.5);
            height: 100%;
            width: 100%;

            #content-fullscreen{
                width: 80%;
                height: auto;

                #btn-close-fullscreen{
                    background-color: white;
                    border: 1px solid rgb(255, 115, 0);
                    margin-bottom: .2em;
                }
            }
        }
    }

    @media only screen and (max-height: 500px) {
        
    }
</style>